<template>
  <v-container fluid v-resize="onResize" class="px-0 py-0">
      <v-card :height="componentHeight" :width="componentWidth" class="overflow-hidden" v-if="!!userId || !!getUser.human_user_id">
        <v-card-title v-if="!!user && !!employee_number">
          {{ user }} ({{ employee_number }})
        </v-card-title>
        <v-tabs @change="updateEvent">
          <v-tab>Calendar</v-tab>
          <v-tab>Statistic</v-tab>
          <v-tab>Errors</v-tab>
          <v-tab>Weekly</v-tab>
          <v-tab>Contracts</v-tab>
          <v-tab>Holidays</v-tab>
          <v-tab>Paid/Bonus</v-tab>
          <v-tab-item>
            <TimeTrackerCalendarEvent
                ref="TimeTrackerCalendarEvent"
                :user-id="userId || getUser.human_user_id"
                dto_model="CalendarDateUserTrackerDTO"
                :subtract-height="400"
            ></TimeTrackerCalendarEvent>
          </v-tab-item>
          <v-tab-item>
            <CalendarDateUserStatistic
                ref="CalendarDateUserStatistic"
                :user-id="userId || getUser.human_user_id"
                :subtract-height="600"
            ></CalendarDateUserStatistic>
          </v-tab-item>
          <v-tab-item>
            <ContractExecution
                ref="ContractExecution"
                :user-id="userId || getUser.human_user_id"
                dto_model="CalendarDateUserErrorDTO"
                :subtract-height="370"
            ></ContractExecution>
          </v-tab-item>
          <v-tab-item>
            <ContractWeekExecution
                :user-id="userId || getUser.human_user_id"
                ref="ContractWeekExecution"
                dto_model="CalendarDateUserWeekDTO"
                :subtract-height="370"
            ></ContractWeekExecution>
          </v-tab-item>
          <v-tab-item>
            <Contract
                ref="Contract"
                :user-id="userId || getUser.human_user_id"
                :subtract-height="220"
            ></Contract>
          </v-tab-item>
          <v-tab-item>
            <TimeTrackerEventHoliday
                ref="TimeTrackerEventHoliday"
                :user-id="userId || getUser.human_user_id"
                :deleted-init="true"
                :subtract-height="340"
            ></TimeTrackerEventHoliday>
          </v-tab-item>
          <v-tab-item>
            <Payed
                ref="Payed"
                :user-id="userId || getUser.human_user_id"
                :subtract-height="280"
            ></Payed>
          </v-tab-item>
        </v-tabs>
      </v-card>
  </v-container>
</template>

<script>
import {debounce} from "debounce"
import {mapGetters, mapActions} from 'vuex';
import {mapFields} from 'vuex-map-fields';
import TimeTrackerEvent from "@/components/TimeTracker/TimeTrackerEvent";
import TimeTrackerCalendarEvent from "@/components/TimeTracker/TimeTrackerCalendarEvent";
import Contract from "@/components/TimeTracker/Contract";
import ContractWeekExecution from "@/components/TimeTracker/ContractWeekExecution";
import CalendarDateUserStatistic from "@/components/TimeTracker/CalendarDateUserStatistic";
import ContractExecution from "@/components/TimeTracker/ContractExecution";
import Payed from "@/components/TimeTracker/Payed";
import TimeTrackerEventHoliday from "@/components/TimeTracker/TimeTrackerEventHoliday";

export default {
  name: 'TimeTrackerHumanInfo',
  props: {
    subtractHeight: {type: [Number], default: 80},
    height: {default: null},
    userId: {default: null},
    user: {default: null},
    employee_number: {default: null},
    modalDialog: {type: [Boolean], default: false},
  },

  components: {
    TimeTrackerEvent,
    TimeTrackerEventHoliday,
    TimeTrackerCalendarEvent,
    Contract,
    ContractWeekExecution,
    CalendarDateUserStatistic,
    ContractExecution,
    Payed,
  },

  computed: {
    ...mapGetters(['getLoggedIn', 'getUser']),
    // ...mapGetters('HumanUser', ['getColumns']),
    // ...mapFields('HumanUser', ['message_error', 'options', 'totalRecords', 'options.page', 'onlyFailedView', 'briefView', 'itemList',
    //   'loading', 'deleteLoading', 'updateLoading', 'restoring', 'selectedItemList', 'searchTermFile', 'searchTerm',
    //   'isAlive', 'action_loading']),

    componentHeight() {
      if (!!this.height)
        return this.height
      if (this.modalDialog)
        return this.windowSize.y * 0.9
      else
        return this.windowSize.y
    },
    componentWidth() {
      if (!!this.width)
        return this.width
      return this.windowSize.x
    },

  },

  methods: {
    ...mapActions('HumanUser', ['openWebSocket', 'fetchItemList', 'fetchItem', 'fetchDeleteSelectedItem',
      'fetchSyncNotionSelectedItems', 'fetchRestoreSelectedItems', 'fetchSaveItemField', 'fetchOrderItemList',
      'fetchActionSelectedItem', 'fetchActionItem']),

    updateEvent(event) {
      // console.log('updateEvent', this.$refs, event)
      if (event === 0 && this.$refs.TimeTrackerCalendarEvent) {
        this.$refs.TimeTrackerCalendarEvent.onUpdateFiltersDefault()
        return
      }
      if (event === 1 && this.$refs.CalendarDateUserStatistic) {
        this.$refs.CalendarDateUserStatistic.onUpdateFilters()
        return
      }
      if (event === 2 && this.$refs.ContractExecution) {
        this.$refs.ContractExecution.onUpdateFilters()
        return
      }
      if (event === 3 && this.$refs.ContractWeekExecution) {
        this.$refs.ContractWeekExecution.onUpdateFilters()
        return
      }
      if (event === 4 && this.$refs.Contract) {
        this.$refs.Contract.onUpdateFilters()
        return
      }
      if (event === 5 && this.$refs.TimeTrackerEventHoliday) {
        this.$refs.TimeTrackerEventHoliday.onUpdateFilters()
        return
      }
      if (event === 6 && this.$refs.Payed) {
        this.$refs.Payed.onUpdateFilters()
        return
      }
    },

    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight };
    },

  },

  async mounted() {
    // console.log('mounted')
  },

  beforeDestroy() {
    // prevent memory leak
    clearInterval(this.interval)
  },

  data() {
    return {
      windowSize: {x: 0, y: 0,},
      dialog: false,
      pin_sending: false,
      pin_code: null,
    }
  }
}
</script>

<style scoped lang="scss">

</style>
